module.exports = __webpack_public_path__ + "img/29.1c2fbed1.jpg";